// extracted by css-extract-rspack-plugin
export default {"cls1":"TagElement-cls1_NBY","cls2":"TagElement-cls2_fLJ TagElement-cls1_NBY"};